var _style, _g, _g2, _g3, _g4, _rect, _g5, _g6, _g7, _rect2, _g8, _g9, _rect3, _g10, _g11, _rect4, _g12, _rect5, _g13, _g14, _rect6, _g15, _rect7, _g16, _g17, _rect8, _rect9, _g18, _rect10, _rect11, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _path, _polygon, _polygon2, _g26, _polygon3, _g27, _g28, _polygon4, _polygon5, _g29, _g30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUlurp2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 676.9 232.4",
    style: {
      enableBackground: "new 0 0 676.9 232.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#303030;}\n\t.st3{fill:#353535;}\n\t.st4{fill:#58595B;}\n\t.st5{fill:none;stroke:#303030;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 81.5,
    className: "st0",
    width: 88,
    height: 22.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.9,86.8l-0.5,1.6H6.5l2.6-7.1h0.8l2.6,7.1h-0.9l-0.5-1.6H7.9z M9.5,82.3l-1.3,3.8h2.7L9.5,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.4,83.3H14l0.1,0.4c0.3-0.4,0.8-0.5,1.5-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.6,0-1-0.1-1.4-0.5v2.6h-0.8V83.3z M16.7,85.5c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8c0,1,0.4,1.5,1.2,1.5 c0.8,0,1.2-0.5,1.2-1.6V85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19,83.3h0.6l0.1,0.4c0.3-0.4,0.8-0.5,1.5-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.6,0-1-0.1-1.4-0.5v2.6H19V83.3z M22.3,85.5c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8c0,1,0.4,1.5,1.2,1.5 c0.8,0,1.2-0.5,1.2-1.6V85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.5,81.2v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7v-5.5H25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.6,81.2h0.8v1.1h-0.8V81.2z M27.6,83.3h0.8v5h-0.8V83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.7,87.7c-0.4,0.5-0.9,0.8-1.7,0.8c-1.3,0-2-0.8-2-2.3v-0.4c0-1.7,0.6-2.5,2-2.5c0.8,0,1.3,0.3,1.7,0.8 L33,84.4c-0.3-0.4-0.5-0.5-1-0.5c-0.8,0-1.2,0.6-1.2,1.7v0.5c0,1,0.4,1.6,1.3,1.6c0.5,0,0.8-0.2,1.1-0.5L33.7,87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.9,85.1c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5L35,84 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6L38,88c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V85.1z M36.8,86c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7V86H36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40,84v-0.7h0.6l0-1.6h0.7v1.6h1V84h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7V84H40 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.8,81.2h0.8v1.1h-0.8V81.2z M43.8,83.3h0.8v5h-0.8V83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.1,85.5c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V85.5z M49.5,85.5c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.9,83.3h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.4-0.7c0.9,0,1.5,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9H55v-2.8 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.9v2.5h-0.8V83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.3,85.1c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5L59.4,84 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6L62.4,88c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V85.1z M61.1,86c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7V86H61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.8,83.3h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.4-0.7c0.9,0,1.5,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8v-2.8 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.9v2.5h-0.8V83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.6,87.9C73.6,88,73.6,88,73.6,87.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.7,0.3-1.3,0.3 c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2c0.4,0,0.8,0.1,1.1,0.2c0,0,0.1,0.1,0.3,0.2v-2.5h0.8v7.1h-0.6L73.6,87.9z  M71,86.2c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.6V86.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.4,99.9H7.6v-7.1h2.3c0.9,0,1.4,0.2,1.8,0.6c0.4,0.4,0.5,0.9,0.5,1.6c0,0.8-0.2,1.3-0.6,1.7 c-0.4,0.3-0.9,0.5-1.7,0.5H8.4V99.9z M9.9,96.4c1,0,1.5-0.5,1.5-1.5s-0.5-1.5-1.5-1.5H8.4v3H9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.5,94.8h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.4,0,0.6,0.1,1,0.3L16,95.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.9,97.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.8,2,2.4v0.4h-3.3V97.7z M20.4,96.9L20.4,96.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.9,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.9,95.9h2.8v0.7h-2.8V95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.3,98.2c-0.1,1.1-0.9,1.8-2.3,1.8c-0.9,0-1.5-0.3-2-0.9c-0.3-0.5-0.4-1-0.4-2v-1.5c0-1.1,0.2-1.7,0.5-2.1 c0.4-0.5,1-0.8,1.9-0.8c1.4,0,2.2,0.6,2.2,1.8l-0.8,0.1c-0.1-0.7-0.6-1.2-1.5-1.2c-1.1,0-1.6,0.6-1.6,2.3V97 c0,1.6,0.4,2.3,1.6,2.3c0.9,0,1.4-0.4,1.5-1.2L32.3,98.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.6,97.7c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.8,2,2.4v0.4h-3.3V97.7z M37.1,96.9L37.1,96.9c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.2-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.4,94.8H40l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3L42,95.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.2,95.5v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47,92.7h0.8v1.1H47V92.7z M47,94.8h0.8v5H47V94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.2,95.5v-0.7h0.6V94c0-1,0.3-1.3,1.4-1.3h0.5v0.6h-0.3c-0.6,0-0.8,0.1-0.8,0.8v0.7h1.1v0.7h-1.1v4.4h-0.8 v-4.4H49.2z M52.9,92.7h0.8v1.1h-0.8V92.7z M52.9,94.8h0.8v5h-0.8V94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59,99.2c-0.4,0.5-0.9,0.8-1.7,0.8c-1.3,0-2-0.8-2-2.3v-0.4c0-1.7,0.6-2.5,2-2.5c0.8,0,1.3,0.3,1.7,0.8 l-0.6,0.3c-0.3-0.4-0.5-0.5-1-0.5c-0.8,0-1.2,0.6-1.2,1.7v0.5c0,1,0.4,1.6,1.3,1.6c0.5,0,0.8-0.2,1.1-0.5L59,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.2,96.6c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.8,1.8-0.8c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V96.6z M62,97.5c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.2,95.5v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H65.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69,92.7h0.8v1.1H69V92.7z M69,94.8h0.8v5H69V94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.4,97c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2V97z  M74.8,97c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.1,94.8h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.4-0.7c0.9,0,1.5,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8v-2.8 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.9v2.5h-0.8V94.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115,165.9l0.3,0c0.4,0,1.1,0.2,1.4,0.5c0.6,0.4,0.8,1.1,0.8,2.3c0,1.2-0.2,1.8-0.7,2.2 c-0.5,0.4-1.1,0.6-2,0.6c-1,0-1.7-0.2-2.2-0.7c-0.4-0.4-0.5-1-0.5-2.1c0-1.1,0.2-1.7,0.7-2.7l1.8-3.2h2.1l-1.8,3H115z M113.9,168.7 c0,1,0.2,1.4,0.9,1.4c0.6,0,0.9-0.3,0.9-1.4s-0.2-1.4-0.9-1.4C114.2,167.3,113.9,167.6,113.9,168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.5,166c0-1.3,0.2-2,0.6-2.5c0.5-0.6,1.1-0.9,2.1-0.9c1.1,0,1.8,0.3,2.3,1c0.3,0.5,0.5,1.2,0.5,2.4v2.1 c0,1.3-0.2,2-0.6,2.5c-0.5,0.6-1.1,0.9-2.1,0.9c-1.1,0-1.8-0.3-2.3-1c-0.3-0.5-0.5-1.2-0.5-2.4V166z M122.2,166.2 c0-1.5-0.2-2-0.9-2c-0.7,0-0.9,0.5-0.9,2v1.8c0,1.5,0.2,2,0.9,2c0.7,0,0.9-0.5,0.9-2V166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.5,171C131.4,171,131.4,171.1,131.5,171c-0.5,0.4-0.9,0.5-1.6,0.5c-1.7,0-2.3-0.8-2.3-2.8v-0.9 c0-2,0.7-2.8,2.3-2.8c0.4,0,0.7,0,1,0.2c0,0,0,0,0.2,0.1c0,0,0,0,0.1,0.1v-2.6h1.8v8.6h-1.3L131.5,171z M129.3,168.6 c0,1.1,0.3,1.5,0.9,1.5c0.6,0,0.9-0.4,0.9-1.2v-1.3c0-0.8-0.3-1.2-0.9-1.2c-0.6,0-0.9,0.5-0.9,1.5V168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.6,167.4c0-0.7-0.3-1-0.9-1c-0.5,0-0.8,0.2-1.2,0.6l-1.2-0.8c0.5-0.8,1.4-1.2,2.5-1.2 c1.2,0,1.9,0.4,2.3,1.1c0.2,0.3,0.2,0.8,0.2,1.6v3.7H138l-0.1-0.3c-0.4,0.3-0.8,0.5-1.6,0.5c-1.5,0-2.1-0.5-2.1-2 c0-1.5,0.6-2,2.3-2h1.1V167.4z M136.7,168.7c-0.6,0-0.9,0.2-0.9,0.8c0,0.5,0.2,0.7,0.9,0.7c0.7,0,0.9-0.2,0.9-1v-0.5H136.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.2,165.2h1.8l1.2,4.2l1.2-4.2h1.8l-2.2,6.5c-0.8,2.2-1.1,2.4-3.3,2.4v-1.4c1,0,1.2-0.1,1.5-1.1l0.1-0.4 L140.2,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.7,169.5c0.3,0.5,0.6,0.6,1.3,0.6c0.8,0,1.1-0.2,1.1-0.7c0-0.3-0.2-0.5-0.7-0.5c-1.1-0.1-1.4-0.2-1.8-0.4 c-0.6-0.3-0.9-0.8-0.9-1.5c0-1.3,0.8-2,2.3-2c1.2,0,2,0.4,2.5,1.3l-1.3,0.7c-0.3-0.5-0.6-0.6-1.1-0.6c-0.5,0-0.8,0.2-0.8,0.6 c0,0.4,0.2,0.5,0.9,0.6c1.9,0.2,2.4,0.6,2.4,2c0,1.4-0.8,2-2.7,2c-1.4,0-2.2-0.4-2.6-1.3L147.7,169.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 147.2,
    className: "st4",
    width: 51.2,
    height: 2.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M227.1,166.2h0.6c0.8,0,1.2-0.3,1.2-1c0-0.6-0.3-1-0.8-1c-0.5,0-0.9,0.3-0.9,0.9l-1.6-0.1 c0.1-1.5,1-2.3,2.7-2.3c1.7,0,2.6,0.8,2.6,2.4c0,0.9-0.2,1.4-0.9,1.8c0.8,0.5,1.1,1,1.1,2.1c0,1.7-0.9,2.6-2.7,2.6 c-1.2,0-2-0.3-2.4-0.9c-0.3-0.4-0.4-0.8-0.5-1.5l1.7-0.2c0.1,0.8,0.4,1.1,1.1,1.1c0.6,0,1-0.4,1-1.1c0-0.8-0.5-1.3-1.3-1.3h-0.7 V166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M232,166c0-1.3,0.2-2,0.6-2.5c0.5-0.6,1.1-0.9,2.1-0.9c1.1,0,1.8,0.3,2.3,1c0.3,0.5,0.5,1.2,0.5,2.4v2.1 c0,1.3-0.2,2-0.6,2.5c-0.5,0.6-1.1,0.9-2.1,0.9c-1.1,0-1.8-0.3-2.3-1c-0.3-0.5-0.5-1.2-0.5-2.4V166z M235.7,166.2 c0-1.5-0.2-2-0.9-2c-0.7,0-0.9,0.5-0.9,2v1.8c0,1.5,0.2,2,0.9,2c0.7,0,0.9-0.5,0.9-2V166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M245,171C244.9,171,244.9,171.1,245,171c-0.5,0.4-0.9,0.5-1.6,0.5c-1.7,0-2.3-0.8-2.3-2.8v-0.9 c0-2,0.7-2.8,2.3-2.8c0.4,0,0.7,0,1,0.2c0,0,0,0,0.2,0.1c0,0,0,0,0.1,0.1v-2.6h1.8v8.6h-1.3L245,171z M242.8,168.6 c0,1.1,0.3,1.5,0.9,1.5c0.6,0,0.9-0.4,0.9-1.2v-1.3c0-0.8-0.3-1.2-0.9-1.2c-0.6,0-0.9,0.5-0.9,1.5V168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.1,167.4c0-0.7-0.3-1-0.9-1c-0.5,0-0.8,0.2-1.2,0.6l-1.2-0.8c0.5-0.8,1.4-1.2,2.5-1.2 c1.2,0,1.9,0.4,2.3,1.1c0.2,0.3,0.2,0.8,0.2,1.6v3.7h-1.4l-0.1-0.3c-0.4,0.3-0.8,0.5-1.6,0.5c-1.5,0-2.1-0.5-2.1-2 c0-1.5,0.6-2,2.3-2h1.1V167.4z M250.2,168.7c-0.6,0-0.9,0.2-0.9,0.8c0,0.5,0.2,0.7,0.9,0.7c0.7,0,0.9-0.2,0.9-1v-0.5H250.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M253.7,165.2h1.8l1.2,4.2l1.2-4.2h1.8l-2.2,6.5c-0.8,2.2-1.1,2.4-3.3,2.4v-1.4c1,0,1.2-0.1,1.5-1.1l0.1-0.4 L253.7,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M261.2,169.5c0.3,0.5,0.6,0.6,1.3,0.6c0.8,0,1.1-0.2,1.1-0.7c0-0.3-0.2-0.5-0.7-0.5c-1.1-0.1-1.4-0.2-1.8-0.4 c-0.6-0.3-0.9-0.8-0.9-1.5c0-1.3,0.8-2,2.3-2c1.2,0,2,0.4,2.5,1.3l-1.3,0.7c-0.3-0.5-0.6-0.6-1.1-0.6c-0.5,0-0.8,0.2-0.8,0.6 c0,0.4,0.2,0.5,0.9,0.6c1.9,0.2,2.4,0.6,2.4,2c0,1.4-0.8,2-2.7,2c-1.4,0-2.2-0.4-2.6-1.3L261.2,169.5z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 36.6,
    className: "st0",
    width: 88,
    height: 38.2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.5,36.6h3c2.3,0,3.4,1,3.3,3.4v1.9c0.1,2.3-1,3.4-3.3,3.4h-3V36.6z M10.1,43.7c1.4,0,1.8-0.4,1.8-2v-1.6 c0-1.6-0.4-2-1.8-2H9.3v5.6H10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.5,36.6h5.4v1.5h-3.6v2h3v1.5h-3v2.1h3.6v1.5h-5.5V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.3,45.2h-1.8v-8.6h2.9c1.2,0,1.9,0.2,2.4,0.7c0.5,0.5,0.6,1.1,0.6,2.1c0,1.1-0.2,1.7-0.8,2.2 c-0.5,0.4-1.1,0.6-2.3,0.6h-1.1V45.2z M25.4,40.7c0.9,0,1.2-0.4,1.2-1.3s-0.3-1.3-1.2-1.3h-1.1v2.6H25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.8,43.6l-0.5,1.6h-2l3.1-8.6h1.8l3.1,8.6h-2l-0.5-1.6H30.8z M32.4,38.8l-1.1,3.3h2.1L32.4,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.9,45.2H37v-8.6h3.3c1.2,0,1.8,0.2,2.2,0.6c0.4,0.4,0.6,1,0.6,1.9c0,1.5-0.4,2.2-1.5,2.5l1.8,3.6h-2 l-1.6-3.4h-0.9V45.2z M40.1,40.4c0.9,0,1.2-0.3,1.2-1.1c0-0.8-0.3-1.1-1.2-1.1h-1.3v2.3H40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.5,38.1h-2.3v-1.5h6.4v1.5h-2.3v7.1h-1.8V38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.9,36.6h1.7l2.2,4.6l2.2-4.6h1.7v8.6H58v-5.1l-1.6,3.3h-1.2l-1.6-3.3v5.1h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.7,36.6h5.4v1.5h-3.6v2h3v1.5h-3v2.1h3.6v1.5h-5.5V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.7,36.6h1.8l3,5.5v-5.5h1.8v8.6h-1.8l-3-5.5v5.5h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.9,38.1h-2.3v-1.5H83v1.5h-2.3v7.1h-1.8V38.1z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.3,54.3c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V54.3z M11.9,54.4 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.5,51h5.3v1.5h-3.5v2.1h2.9v1.5h-2.9v3.5h-1.8V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.5,57.3c0,0.8-0.2,1.2-0.6,1.7c-0.5,0.5-1.3,0.8-2.5,0.8c-1.2,0-2-0.3-2.6-1c-0.4-0.6-0.6-1.2-0.6-2.4v-1.9 c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.4-0.9c1.9,0,2.9,0.8,3,2.5l-1.7,0.1c-0.1-0.8-0.5-1.2-1.2-1.2c-1,0-1.3,0.5-1.3,2.1v1.6 c0,1.6,0.3,2.1,1.3,2.1c0.8,0,1.2-0.4,1.3-1.2L30.5,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.9,51h1.8v8.6h-1.8V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.3,52.5h-2.3V51h6.4v1.5h-2.3v7.1h-1.8V52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.8,56.5L42.1,51h2l1.6,3.7l1.6-3.7h2l-2.6,5.5v3.1h-1.8V56.5z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.3,74H7.5v-8.6h2.9c1.2,0,1.9,0.2,2.4,0.7c0.5,0.5,0.6,1.1,0.6,2.1c0,1.1-0.2,1.7-0.8,2.2 c-0.5,0.4-1.1,0.6-2.3,0.6H9.3V74z M10.4,69.5c0.9,0,1.2-0.4,1.2-1.3s-0.3-1.3-1.2-1.3H9.3v2.6H10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.8,65.4h1.8v7.1h3.6V74h-5.5V65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.5,72.4L23,74h-2l3.1-8.6h1.8L29,74h-2l-0.5-1.6H23.5z M25,67.6l-1.1,3.3H26L25,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.7,65.4h1.8l3,5.5v-5.5h1.8V74h-1.8l-3-5.5V74h-1.8V65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.2,65.4H40l3,5.5v-5.5h1.8V74H43l-3-5.5V74h-1.8V65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.7,65.4h1.8V74h-1.8V65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.5,65.4h1.8l3,5.5v-5.5h1.8V74h-1.8l-3-5.5V74h-1.8V65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.2,69.2h3.1v1.5c0,1.3-0.1,1.9-0.6,2.4c-0.6,0.7-1.4,1-2.7,1c-1.3,0-2.1-0.3-2.6-1 c-0.4-0.6-0.6-1.2-0.6-2.4v-1.9c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.5-0.9c2,0,3,0.8,3,2.5L63.4,68c-0.1-0.8-0.5-1.2-1.3-1.2 c-1,0-1.4,0.5-1.4,2.1v1.6c0,1.6,0.3,2.1,1.4,2.1c1,0,1.4-0.5,1.4-1.6v-0.5h-1.3V69.2z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 36.6,
    className: "st0",
    width: 89.1,
    height: 41.4
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M236.3,36.6h3.4c1,0,1.6,0.1,2,0.5c0.5,0.4,0.7,1,0.7,1.8c0,0.8-0.2,1.4-0.7,1.8c0.3,0.3,0.4,0.4,0.5,0.5 c0.2,0.4,0.3,0.9,0.3,1.5c0,0.9-0.3,1.5-0.8,2c-0.4,0.3-0.9,0.4-1.9,0.4h-3.5V36.6z M239.6,40.1c0.7,0,1-0.3,1-1c0-0.7-0.3-1-1-1 h-1.4v2H239.6z M239.7,43.7c0.7,0,1-0.3,1-1.1c0-0.8-0.3-1.1-1-1.1h-1.6v2.2H239.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M243.9,39.9c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V39.9z M248.6,40.1 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M254,45.2h-1.8v-8.6h3.2c1.2,0,1.8,0.2,2.2,0.6c0.4,0.4,0.6,1,0.6,1.9c0,1.5-0.4,2.2-1.5,2.5l1.8,3.5h-2 l-1.6-3.4H254V45.2z M255.2,40.4c0.9,0,1.2-0.3,1.2-1.1c0-0.8-0.3-1.1-1.2-1.1h-1.3v2.3H255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M259.7,39.9c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V39.9z M264.3,40.1 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M269.7,36.6V42c0,0.7,0,1,0.2,1.3c0.2,0.4,0.5,0.6,1.1,0.6c0.7,0,1-0.2,1.2-0.6c0.1-0.3,0.1-0.6,0.1-1.2v-5.4 h1.8V42c0,1.3-0.1,1.8-0.5,2.4c-0.6,0.7-1.3,1-2.6,1c-1.4,0-2.2-0.3-2.7-1.1c-0.3-0.5-0.4-1-0.4-2.2v-5.4H269.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M279.2,40.4h3.1v1.5c0,1.3-0.1,1.9-0.6,2.4c-0.6,0.7-1.4,1-2.7,1c-1.3,0-2.1-0.3-2.6-1 c-0.4-0.6-0.6-1.2-0.6-2.4V40c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.5-0.9c2,0,3,0.8,3,2.5l-1.7,0.1c-0.1-0.8-0.5-1.2-1.3-1.2 c-1,0-1.4,0.5-1.4,2.1v1.6c0,1.6,0.3,2.1,1.4,2.1c1,0,1.4-0.5,1.4-1.6v-0.5h-1.3V40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M283.9,36.6h1.8v3.5h2.5v-3.5h1.8v8.6h-1.8v-3.6h-2.5v3.6h-1.8V36.6z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M238.2,59.6h-1.8V51h2.9c1.2,0,1.9,0.2,2.4,0.7c0.5,0.5,0.6,1.1,0.6,2.1c0,1.1-0.2,1.7-0.8,2.2 c-0.5,0.4-1.1,0.6-2.3,0.6h-1.1V59.6z M239.3,55.1c0.9,0,1.2-0.4,1.2-1.3c0-1-0.3-1.3-1.2-1.3h-1.1v2.6H239.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M245.5,59.6h-1.8V51h3.2c1.2,0,1.8,0.2,2.2,0.6c0.4,0.4,0.6,1,0.6,1.9c0,1.5-0.4,2.2-1.5,2.5l1.8,3.5h-2 l-1.6-3.4h-0.9V59.6z M246.8,54.8c0.9,0,1.2-0.3,1.2-1.1c0-0.8-0.3-1.1-1.2-1.1h-1.3v2.3H246.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.5,51h5.4v1.5h-3.6v2h3V56h-3v2.1h3.6v1.5h-5.5V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M259.4,57.3c0.4,0.6,0.9,0.9,1.9,0.9c0.9,0,1.3-0.3,1.3-1c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.2-0.2-0.2-1.4-0.5 c-1.8-0.4-2.4-1.2-2.4-2.6c0-1.6,1-2.5,2.9-2.5c1.4,0,2.3,0.5,2.9,1.4l-1.4,0.9c-0.4-0.6-0.9-0.8-1.5-0.8c-0.7,0-1.1,0.3-1.1,0.9 c0,0.7,0.4,0.9,1.6,1.2c1.1,0.3,1.4,0.4,1.8,0.6c0.6,0.4,0.8,1,0.8,1.9c0,0.9-0.2,1.5-0.7,1.9c-0.5,0.5-1.4,0.7-2.4,0.7 c-0.9,0-1.8-0.2-2.4-0.6c-0.4-0.2-0.6-0.5-0.9-0.9L259.4,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.7,51h1.8v8.6h-1.8V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M269.5,51h3c2.3,0,3.4,1,3.3,3.3v1.9c0.1,2.3-1,3.4-3.3,3.3h-3V51z M272.1,58.1c1.4,0,1.8-0.4,1.8-2v-1.6 c0-1.6-0.4-2-1.8-2h-0.8v5.6H272.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M277.5,51h5.4v1.5h-3.6v2h3V56h-3v2.1h3.6v1.5h-5.5V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M284.5,51h1.8l3,5.5V51h1.8v8.6h-1.8l-3-5.5v5.5h-1.8V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.6,52.5h-2.3V51h6.4v1.5h-2.3v7.1h-1.8V52.5z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120.4,
    y: 36.6,
    className: "st0",
    width: 88.6,
    height: 26.6
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.4,42.9c0,0.8-0.2,1.2-0.6,1.7c-0.5,0.5-1.3,0.8-2.5,0.8c-1.2,0-2-0.3-2.6-1c-0.4-0.6-0.6-1.2-0.6-2.4V40 c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.4-0.9c1.9,0,2.9,0.8,3,2.5l-1.7,0.1c-0.1-0.8-0.5-1.2-1.2-1.2c-1,0-1.3,0.5-1.3,2.1v1.6 c0,1.6,0.3,2.1,1.3,2.1c0.8,0,1.2-0.4,1.3-1.2L127.4,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M128.7,39.9c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V39.9z M133.4,40.1 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137,36.6h1.7l2.2,4.6l2.2-4.6h1.7v8.6h-1.8v-5.1l-1.6,3.2h-1.2l-1.6-3.2v5.1H137V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.7,36.6h1.7l2.2,4.6l2.2-4.6h1.7v8.6h-1.8v-5.1l-1.6,3.2h-1.2l-1.6-3.2v5.1h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158.3,36.6V42c0,0.7,0,1,0.2,1.3c0.2,0.4,0.5,0.6,1.1,0.6c0.7,0,1-0.2,1.2-0.6c0.1-0.3,0.1-0.6,0.1-1.2v-5.4 h1.8V42c0,1.3-0.1,1.8-0.5,2.4c-0.6,0.7-1.3,1-2.6,1c-1.4,0-2.2-0.3-2.7-1.1c-0.3-0.5-0.4-1-0.4-2.2v-5.4H158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M164.7,36.6h1.8l3,5.5v-5.5h1.8v8.6h-1.8l-3-5.5v5.5h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M173.2,36.6h1.8v8.6h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.7,38.1h-2.3v-1.5h6.4v1.5h-2.3v7.1h-1.8V38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M186.1,42.1l-2.6-5.5h2l1.6,3.7l1.6-3.7h2l-2.6,5.5v3.1h-1.8V42.1z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M121.4,51h3.4c1,0,1.6,0.1,2,0.5c0.5,0.4,0.7,1,0.7,1.8c0,0.8-0.2,1.4-0.7,1.8c0.3,0.3,0.4,0.4,0.5,0.5 c0.2,0.4,0.3,0.9,0.3,1.5c0,0.9-0.3,1.5-0.8,2c-0.4,0.3-0.9,0.4-1.9,0.4h-3.5V51z M124.6,54.5c0.7,0,1-0.3,1-1c0-0.7-0.3-1-1-1 h-1.4v2H124.6z M124.8,58.1c0.7,0,1-0.3,1-1.1c0-0.8-0.3-1.1-1-1.1h-1.6v2.2H124.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129,54.3c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V54.3z M133.6,54.5 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M138.6,58l-0.5,1.6h-2l3.1-8.6h1.8l3.1,8.6h-2l-0.5-1.6H138.6z M140.1,53.2l-1.1,3.3h2.1L140.1,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.6,59.6h-1.8V51h3.2c1.2,0,1.8,0.2,2.2,0.6c0.4,0.4,0.6,1,0.6,1.9c0,1.5-0.4,2.2-1.5,2.5l1.8,3.5h-2 l-1.6-3.4h-0.9V59.6z M147.9,54.8c0.9,0,1.2-0.3,1.2-1.1c0-0.8-0.3-1.1-1.2-1.1h-1.3v2.3H147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M152.6,51h3c2.3,0,3.4,1,3.3,3.3v1.9c0.1,2.3-1,3.4-3.3,3.3h-3V51z M155.2,58.1c1.4,0,1.8-0.4,1.8-2v-1.6 c0-1.6-0.4-2-1.8-2h-0.8v5.6H155.2z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 225.8,
    y: 34.9,
    className: "st4",
    width: 0.8,
    height: 91.1
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M455.9,162.8h4.5v1.5h-2.9l-0.1,1.6l0.1,0c0.3-0.1,0.4-0.1,0.7-0.1c0.9,0,1.6,0.3,2,0.7c0.4,0.4,0.6,1,0.6,2.1 c0,1.1-0.2,1.7-0.6,2.1c-0.5,0.5-1.2,0.7-2.2,0.7c-1.7,0-2.6-0.8-2.7-2.4l1.7-0.2c0.1,0.7,0.4,1.1,1,1.1c0.6,0,0.9-0.4,0.9-1.3 c0-1.1-0.3-1.5-1-1.5c-0.4,0-0.7,0.2-1,0.5l-1.3-0.3L455.9,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M461.8,166c0-1.3,0.2-2,0.6-2.5c0.5-0.6,1.1-0.9,2.1-0.9c1.1,0,1.8,0.3,2.3,1c0.3,0.5,0.5,1.2,0.5,2.4v2.1 c0,1.3-0.2,2-0.6,2.5c-0.5,0.6-1.1,0.9-2.1,0.9c-1.1,0-1.8-0.3-2.3-1c-0.3-0.5-0.5-1.2-0.5-2.4V166z M465.4,166.2 c0-1.5-0.2-2-0.9-2c-0.7,0-0.9,0.5-0.9,2v1.8c0,1.5,0.2,2,0.9,2c0.7,0,0.9-0.5,0.9-2V166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M474.7,171C474.7,171,474.6,171.1,474.7,171c-0.5,0.4-0.9,0.5-1.6,0.5c-1.7,0-2.3-0.8-2.3-2.8v-0.9 c0-2,0.7-2.8,2.3-2.8c0.4,0,0.7,0,1,0.2c0,0,0,0,0.2,0.1c0,0,0,0,0.1,0.1v-2.6h1.8v8.6h-1.3L474.7,171z M472.5,168.6 c0,1.1,0.3,1.5,0.9,1.5c0.6,0,0.9-0.4,0.9-1.2v-1.3c0-0.8-0.3-1.2-0.9-1.2c-0.6,0-0.9,0.5-0.9,1.5V168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M480.9,167.4c0-0.7-0.3-1-0.9-1c-0.5,0-0.8,0.2-1.2,0.6l-1.2-0.8c0.5-0.8,1.4-1.2,2.5-1.2 c1.2,0,1.9,0.4,2.3,1.1c0.2,0.3,0.2,0.8,0.2,1.6v3.7h-1.4l-0.1-0.3c-0.4,0.3-0.8,0.5-1.6,0.5c-1.5,0-2.1-0.5-2.1-2 c0-1.5,0.6-2,2.3-2h1.1V167.4z M479.9,168.7c-0.6,0-0.9,0.2-0.9,0.8c0,0.5,0.2,0.7,0.9,0.7c0.7,0,0.9-0.2,0.9-1v-0.5H479.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M483.4,165.2h1.8l1.2,4.2l1.2-4.2h1.8l-2.2,6.5c-0.8,2.2-1.1,2.4-3.3,2.4v-1.4c1,0,1.2-0.1,1.5-1.1l0.1-0.4 L483.4,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M491,169.5c0.3,0.5,0.6,0.6,1.3,0.6c0.8,0,1.1-0.2,1.1-0.7c0-0.3-0.2-0.5-0.7-0.5c-1.1-0.1-1.4-0.2-1.8-0.4 c-0.6-0.3-0.9-0.8-0.9-1.5c0-1.3,0.8-2,2.3-2c1.2,0,2,0.4,2.5,1.3l-1.3,0.7c-0.3-0.5-0.6-0.6-1.1-0.6c-0.5,0-0.8,0.2-0.8,0.6 c0,0.4,0.2,0.5,0.9,0.6c1.9,0.2,2.4,0.6,2.4,2c0,1.4-0.8,2-2.7,2c-1.4,0-2.2-0.4-2.6-1.3L491,169.5z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 349.4,
    y: 36.6,
    className: "st0",
    width: 88.2,
    height: 41.4
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M356.3,42.9c0,0.8-0.2,1.2-0.6,1.7c-0.5,0.5-1.3,0.8-2.5,0.8c-1.2,0-2-0.3-2.6-1c-0.4-0.6-0.6-1.2-0.6-2.4V40 c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.4-0.9c1.9,0,2.9,0.8,3,2.5l-1.7,0.1c-0.1-0.8-0.5-1.2-1.2-1.2c-1,0-1.3,0.5-1.3,2.1v1.6 c0,1.6,0.3,2.1,1.3,2.1c0.8,0,1.2-0.4,1.3-1.2L356.3,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M357.8,36.6h1.8v8.6h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M363.2,38.1h-2.3v-1.5h6.4v1.5H365v7.1h-1.8V38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M370.6,42.1l-2.6-5.5h2l1.6,3.7l1.6-3.7h2l-2.6,5.5v3.1h-1.8V42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M380,45.2h-1.8v-8.6h2.9c1.2,0,1.9,0.2,2.4,0.7c0.5,0.5,0.6,1.1,0.6,2.1c0,1.1-0.2,1.7-0.8,2.2 c-0.5,0.4-1.1,0.6-2.3,0.6H380V45.2z M381.1,40.7c0.9,0,1.2-0.4,1.2-1.3c0-1-0.3-1.3-1.2-1.3H380v2.6H381.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M385.5,36.6h1.8v7.1h3.6v1.5h-5.5V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M394.2,43.6l-0.5,1.6h-2l3.1-8.6h1.8l3.1,8.6h-2l-0.5-1.6H394.2z M395.7,38.8l-1.1,3.3h2.1L395.7,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M400.4,36.6h1.8l3,5.5v-5.5h1.8v8.6h-1.8l-3-5.5v5.5h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M408.9,36.6h1.8l3,5.5v-5.5h1.8v8.6h-1.8l-3-5.5v5.5h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M417.4,36.6h1.8v8.6h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M421.2,36.6h1.8l3,5.5v-5.5h1.8v8.6H426l-3-5.5v5.5h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M432.8,40.4h3.1v1.5c0,1.3-0.1,1.9-0.6,2.4c-0.6,0.7-1.4,1-2.7,1c-1.3,0-2.1-0.3-2.6-1 c-0.4-0.6-0.6-1.2-0.6-2.4V40c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.5-0.9c2,0,3,0.8,3,2.5l-1.7,0.1c-0.1-0.8-0.5-1.2-1.3-1.2 c-1,0-1.4,0.5-1.4,2.1v1.6c0,1.6,0.3,2.1,1.4,2.1c1,0,1.4-0.5,1.4-1.6v-0.5h-1.3V40.4z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M356.3,57.3c0,0.8-0.2,1.2-0.6,1.7c-0.5,0.5-1.3,0.8-2.5,0.8c-1.2,0-2-0.3-2.6-1c-0.4-0.6-0.6-1.2-0.6-2.4 v-1.9c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.4-0.9c1.9,0,2.9,0.8,3,2.5l-1.7,0.1c-0.1-0.8-0.5-1.2-1.2-1.2c-1,0-1.3,0.5-1.3,2.1 v1.6c0,1.6,0.3,2.1,1.3,2.1c0.8,0,1.2-0.4,1.3-1.2L356.3,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M357.7,54.3c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V54.3z M362.3,54.5 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M365.9,51h1.7l2.2,4.6L372,51h1.7v8.6H372v-5.1l-1.6,3.2h-1.2l-1.6-3.2v5.1h-1.8V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M375.7,51h1.7l2.2,4.6l2.2-4.6h1.7v8.6h-1.8v-5.1l-1.6,3.2H379l-1.6-3.2v5.1h-1.8V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M385.5,51h1.8v8.6h-1.8V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M389.8,57.3c0.4,0.6,0.9,0.9,1.9,0.9c0.9,0,1.3-0.3,1.3-1c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.2-0.2-0.2-1.4-0.5 c-1.8-0.4-2.4-1.2-2.4-2.6c0-1.6,1-2.5,2.9-2.5c1.4,0,2.3,0.5,2.9,1.4l-1.4,0.9c-0.4-0.6-0.9-0.8-1.5-0.8c-0.7,0-1.1,0.3-1.1,0.9 c0,0.7,0.4,0.9,1.6,1.2c1.1,0.3,1.4,0.4,1.8,0.6c0.6,0.4,0.8,1,0.8,1.9c0,0.9-0.2,1.5-0.7,1.9c-0.5,0.5-1.4,0.7-2.4,0.7 c-0.9,0-1.8-0.2-2.4-0.6c-0.4-0.2-0.6-0.5-0.9-0.9L389.8,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M396.1,51h1.8v8.6h-1.8V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M399.7,54.3c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V54.3z M404.3,54.5 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M407.9,51h1.8l3,5.5V51h1.8v8.6h-1.8l-3-5.5v5.5h-1.8V51z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 339.8,
    y: 34.9,
    className: "st4",
    width: 0.8,
    height: 91.1
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M570,162.8h4.5v1.5h-2.9l-0.1,1.6l0.1,0c0.3-0.1,0.4-0.1,0.7-0.1c0.9,0,1.6,0.3,2,0.7c0.4,0.4,0.6,1,0.6,2.1 c0,1.1-0.2,1.7-0.6,2.1c-0.5,0.5-1.2,0.7-2.2,0.7c-1.7,0-2.6-0.8-2.7-2.4l1.7-0.2c0.1,0.7,0.4,1.1,1,1.1c0.6,0,0.9-0.4,0.9-1.3 c0-1.1-0.3-1.5-1-1.5c-0.4,0-0.7,0.2-1,0.5l-1.3-0.3L570,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M582.3,171C582.2,171,582.2,171.1,582.3,171c-0.5,0.4-0.9,0.5-1.6,0.5c-1.7,0-2.3-0.8-2.3-2.8v-0.9 c0-2,0.7-2.8,2.3-2.8c0.4,0,0.7,0,1,0.2c0,0,0,0,0.2,0.1c0,0,0,0,0.1,0.1v-2.6h1.8v8.6h-1.3L582.3,171z M580.1,168.6 c0,1.1,0.3,1.5,0.9,1.5c0.6,0,0.9-0.4,0.9-1.2v-1.3c0-0.8-0.3-1.2-0.9-1.2c-0.6,0-0.9,0.5-0.9,1.5V168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M588.4,167.4c0-0.7-0.3-1-0.9-1c-0.5,0-0.8,0.2-1.2,0.6l-1.2-0.8c0.5-0.8,1.4-1.2,2.5-1.2 c1.2,0,1.9,0.4,2.3,1.1c0.2,0.3,0.2,0.8,0.2,1.6v3.7h-1.4l-0.1-0.3c-0.4,0.3-0.8,0.5-1.6,0.5c-1.5,0-2.1-0.5-2.1-2 c0-1.5,0.6-2,2.3-2h1.1V167.4z M587.5,168.7c-0.6,0-0.9,0.2-0.9,0.8c0,0.5,0.2,0.7,0.9,0.7c0.7,0,0.9-0.2,0.9-1v-0.5H587.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M591,165.2h1.8l1.2,4.2l1.2-4.2h1.8l-2.2,6.5c-0.8,2.2-1.1,2.4-3.3,2.4v-1.4c1,0,1.2-0.1,1.5-1.1l0.1-0.4 L591,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M598.5,169.5c0.3,0.5,0.6,0.6,1.3,0.6c0.8,0,1.1-0.2,1.1-0.7c0-0.3-0.2-0.5-0.7-0.5c-1.1-0.1-1.4-0.2-1.8-0.4 c-0.6-0.3-0.9-0.8-0.9-1.5c0-1.3,0.8-2,2.3-2c1.2,0,2,0.4,2.5,1.3l-1.3,0.7c-0.3-0.5-0.6-0.6-1.1-0.6c-0.5,0-0.8,0.2-0.8,0.6 c0,0.4,0.2,0.5,0.9,0.6c1.9,0.2,2.4,0.6,2.4,2c0,1.4-0.8,2-2.7,2c-1.4,0-2.2-0.4-2.6-1.3L598.5,169.5z"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 465.3,
    y: 36.6,
    className: "st0",
    width: 88.3,
    height: 34
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M472.3,42.9c0,0.8-0.2,1.2-0.6,1.7c-0.5,0.5-1.3,0.8-2.5,0.8c-1.2,0-2-0.3-2.6-1c-0.4-0.6-0.6-1.2-0.6-2.4V40 c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.4-0.9c1.9,0,2.9,0.8,3,2.5l-1.7,0.1c-0.1-0.8-0.5-1.2-1.2-1.2c-1,0-1.3,0.5-1.3,2.1v1.6 c0,1.6,0.3,2.1,1.3,2.1c0.8,0,1.2-0.4,1.3-1.2L472.3,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M473.7,36.6h1.8v8.6h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M479.2,38.1h-2.3v-1.5h6.4v1.5H481v7.1h-1.8V38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M486.6,42.1l-2.6-5.5h2l1.6,3.7l1.6-3.7h2l-2.6,5.5v3.1h-1.8V42.1z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M472.3,57.3c0,0.8-0.2,1.2-0.6,1.7c-0.5,0.5-1.3,0.8-2.5,0.8c-1.2,0-2-0.3-2.6-1c-0.4-0.6-0.6-1.2-0.6-2.4 v-1.9c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.4-0.9c1.9,0,2.9,0.8,3,2.5l-1.7,0.1c-0.1-0.8-0.5-1.2-1.2-1.2c-1,0-1.3,0.5-1.3,2.1 v1.6c0,1.6,0.3,2.1,1.3,2.1c0.8,0,1.2-0.4,1.3-1.2L472.3,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M473.7,54.3c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V54.3z M478.3,54.5 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M483.7,51v5.4c0,0.7,0,1,0.2,1.3c0.2,0.4,0.5,0.6,1.1,0.6c0.7,0,1-0.2,1.2-0.6c0.1-0.3,0.1-0.6,0.1-1.2V51h1.8 v5.4c0,1.3-0.1,1.8-0.5,2.4c-0.6,0.7-1.3,1-2.6,1c-1.4,0-2.2-0.3-2.7-1.1c-0.3-0.5-0.4-1-0.4-2.2V51H483.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M490.1,51h1.8l3,5.5V51h1.8v8.6h-1.8l-3-5.5v5.5h-1.8V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M504.6,57.3c0,0.8-0.2,1.2-0.6,1.7c-0.5,0.5-1.3,0.8-2.5,0.8c-1.2,0-2-0.3-2.6-1c-0.4-0.6-0.6-1.2-0.6-2.4 v-1.9c0-1.3,0.2-2,0.7-2.6c0.6-0.6,1.3-0.9,2.4-0.9c1.9,0,2.9,0.8,3,2.5l-1.7,0.1c-0.1-0.8-0.5-1.2-1.2-1.2c-1,0-1.3,0.5-1.3,2.1 v1.6c0,1.6,0.3,2.1,1.3,2.1c0.8,0,1.2-0.4,1.3-1.2L504.6,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M506,51h1.8v8.6H506V51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M509.8,51h1.8v7.1h3.6v1.5h-5.5V51z"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 455.8,
    y: 34.9,
    className: "st4",
    width: 0.8,
    height: 91.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 578.4,
    y: 36.6,
    className: "st0",
    width: 88.5,
    height: 34
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M579.4,36.6h1.7l2.2,4.6l2.2-4.6h1.7v8.6h-1.8v-5.1l-1.6,3.2h-1.2l-1.6-3.2v5.1h-1.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M590.8,43.6l-0.5,1.6h-2l3.1-8.6h1.8l3.1,8.6h-2l-0.5-1.6H590.8z M592.4,38.8l-1.1,3.3h2.1L592.4,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M598.1,42.1l-2.6-5.5h2l1.6,3.7l1.6-3.7h2l-2.6,5.5v3.1h-1.8V42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M603.2,39.9c0-1.3,0.2-2,0.7-2.5c0.6-0.6,1.3-0.9,2.5-0.9c1.3,0,2.1,0.3,2.7,1c0.4,0.5,0.6,1.2,0.6,2.4v2 c0,1.3-0.2,2-0.7,2.5c-0.6,0.6-1.3,0.9-2.5,0.9c-1.3,0-2.1-0.3-2.7-1c-0.4-0.5-0.6-1.2-0.6-2.4V39.9z M607.8,40.1 c0-1.6-0.3-2.1-1.4-2.1c-1.1,0-1.4,0.5-1.4,2.1v1.7c0,1.6,0.3,2.1,1.4,2.1c1.1,0,1.4-0.5,1.4-2.1V40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M613.2,45.2h-1.8v-8.6h3.2c1.2,0,1.8,0.2,2.2,0.6c0.4,0.4,0.6,1,0.6,1.9c0,1.5-0.4,2.2-1.5,2.5l1.8,3.5h-2 l-1.6-3.4h-0.9V45.2z M614.5,40.4c0.9,0,1.2-0.3,1.2-1.1c0-0.8-0.3-1.1-1.2-1.1h-1.3v2.3H614.5z"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 568.8,
    y: 34.9,
    className: "st4",
    width: 0.8,
    height: 91.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 111.3,
    y: 34.9,
    className: "st4",
    width: 0.8,
    height: 91.1
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.5,147.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6L75,146.8c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 L86.5,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86,145.1c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6L74.5,144c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6L86,145.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.5,141.5c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6H74c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6H79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M82.4,155h-5.5c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h5.5c0.3,0,0.6-0.3,0.6-0.6S82.7,155,82.4,155z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M84.5,129.5c-10.2,0.1-18.4,8.4-18.3,18.6c0.1,10.2,8.4,18.4,18.6,18.3c10.2-0.1,18.4-8.4,18.3-18.6 C103,137.7,94.7,129.4,84.5,129.5z M75.2,158.9c-2.1-1.6-3.4-9.1-3.5-20.2l16.6-0.1c0.1,6.5,0.6,16.8,3.2,20.2L75.2,158.9z  M95.8,151.1V149h-5.2v-2.2h5.2v-2.1l4.4,3.1L95.8,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.9,149.5l-11.5,0.1c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6l11.5-0.1c0.3,0,0.6-0.3,0.6-0.6 C87.5,149.7,87.3,149.5,86.9,149.5z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M127.5,15c-0.1-0.6-0.3-1.3-0.3-1.8c-0.2,0-0.7,0.1-1,0.1c-0.7,0-1.4,0.2-1.9,0.3c0.2,0.3,0.4,1,0.6,1.4 c0.3,0.6,0.6,1.2,0.9,1.8c0.3,0.5,0.6,0.8,0.8,0.9l0,0c0.2,0.1,0.5,0.2,0.6,0.1l1-0.2c0.1,0,0.2-0.1,0.3-0.2s0.1-0.2,0.1-0.3 c0-0.3-0.2-0.5-0.5-0.9C127.8,15.9,127.6,15.6,127.5,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M125.5,13.7l-0.9-3.9c-0.3,0.1-1.8,0.4-2,0.4c-0.7,0.1-1.1,0.8-0.9,1.5l0.3,1.5c0.1,0.7,0.8,1.1,1.5,0.9 L125.5,13.7L125.5,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.2,15.5c-1-4.7-1.6-7.4-2.6-11.8c0-0.2-0.3-0.3-0.5-0.3c-0.1,0-0.2,0.1-0.2,0.2c-1.4,2.8-3.3,4.1-7.2,5.2 c-0.1,0-0.4,0.1-0.7,0.2c-0.4,0.1-0.6,0.5-0.5,0.9l0.8,3.6c0.1,0.4,0.5,0.7,0.9,0.6l0.3-0.1c0.8-0.1,2.1-0.2,2.1-0.2 c3.1-0.2,4.7,0.4,6.8,2c0.1,0.1,0.3,0.1,0.4,0S136.2,15.6,136.2,15.5z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M242.6,15c-0.1-0.6-0.3-1.3-0.3-1.8c-0.2,0-0.7,0.1-1,0.1c-0.7,0-1.4,0.2-1.9,0.3c0.2,0.3,0.4,1,0.6,1.4 c0.3,0.6,0.6,1.2,0.9,1.8c0.3,0.5,0.6,0.8,0.8,0.9l0,0c0.2,0.1,0.5,0.2,0.6,0.1l1-0.2c0.1,0,0.2-0.1,0.3-0.2s0.1-0.2,0.1-0.3 c0-0.3-0.2-0.5-0.5-0.9C242.9,15.9,242.7,15.6,242.6,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M240.6,13.7l-0.9-3.9c-0.3,0.1-1.8,0.4-2,0.4c-0.7,0.1-1.1,0.8-0.9,1.5l0.3,1.5c0.1,0.7,0.8,1.1,1.5,0.9 L240.6,13.7L240.6,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M251.2,15.5c-1-4.7-1.6-7.4-2.6-11.8c0-0.2-0.3-0.3-0.5-0.3c-0.1,0-0.2,0.1-0.2,0.2c-1.4,2.8-3.3,4.1-7.2,5.2 c-0.1,0-0.4,0.1-0.7,0.2c-0.4,0.1-0.6,0.5-0.5,0.9l0.8,3.6c0.1,0.4,0.5,0.7,0.9,0.6l0.3-0.1c0.8-0.1,2.1-0.2,2.1-0.2 c3.1-0.2,4.7,0.4,6.8,2c0.1,0.1,0.3,0.1,0.4,0S251.3,15.6,251.2,15.5z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M356.5,15c-0.1-0.6-0.3-1.3-0.3-1.8c-0.2,0-0.7,0.1-1,0.1c-0.7,0-1.4,0.2-1.9,0.3c0.2,0.3,0.4,1,0.6,1.4 c0.3,0.6,0.6,1.2,0.9,1.8c0.3,0.5,0.6,0.8,0.8,0.9l0,0c0.2,0.1,0.5,0.2,0.6,0.1l1-0.2c0.1,0,0.2-0.1,0.3-0.2 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.3-0.2-0.5-0.5-0.9C356.9,15.9,356.7,15.6,356.5,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M354.5,13.7l-0.9-3.9c-0.3,0.1-1.8,0.4-2,0.4c-0.7,0.1-1.1,0.8-0.9,1.5l0.3,1.5c0.1,0.7,0.8,1.1,1.5,0.9 L354.5,13.7L354.5,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M365.2,15.5c-1-4.7-1.6-7.4-2.6-11.8c0-0.2-0.3-0.3-0.5-0.3c-0.1,0-0.2,0.1-0.2,0.2c-1.4,2.8-3.3,4.1-7.2,5.2 c-0.1,0-0.4,0.1-0.7,0.2c-0.4,0.1-0.6,0.5-0.5,0.9l0.8,3.6c0.1,0.4,0.5,0.7,0.9,0.6l0.3-0.1c0.8-0.1,2.1-0.2,2.1-0.2 c3.1-0.2,4.7,0.4,6.8,2c0.1,0.1,0.3,0.1,0.4,0C365.1,15.8,365.2,15.6,365.2,15.5z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M472.3,15c-0.1-0.6-0.3-1.3-0.3-1.8c-0.2,0-0.7,0.1-1,0.1c-0.7,0-1.4,0.2-1.9,0.3c0.2,0.3,0.4,1,0.6,1.4 c0.3,0.6,0.6,1.2,0.9,1.8c0.3,0.5,0.6,0.8,0.8,0.9l0,0c0.2,0.1,0.5,0.2,0.6,0.1l1-0.2c0.1,0,0.2-0.1,0.3-0.2 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.3-0.2-0.5-0.5-0.9C472.7,15.9,472.5,15.6,472.3,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M470.3,13.7l-0.9-3.9c-0.3,0.1-1.8,0.4-2,0.4c-0.7,0.1-1.1,0.8-0.9,1.5l0.3,1.5c0.1,0.7,0.8,1.1,1.5,0.9 L470.3,13.7L470.3,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M481,15.5c-1-4.7-1.6-7.4-2.6-11.8c0-0.2-0.3-0.3-0.5-0.3c-0.1,0-0.2,0.1-0.2,0.2c-1.4,2.8-3.3,4.1-7.2,5.2 c-0.1,0-0.4,0.1-0.7,0.2c-0.4,0.1-0.6,0.5-0.5,0.9l0.8,3.6c0.1,0.4,0.5,0.7,0.9,0.6l0.3-0.1c0.8-0.1,2.1-0.2,2.1-0.2 c3.1-0.2,4.7,0.4,6.8,2c0.1,0.1,0.3,0.1,0.4,0S481,15.6,481,15.5z"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "195.8,144.5 201.4,151.8 201.5,151.9 202.3,151.3 196.6,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "194,145.8 193.2,146.4 198.9,153.8 198.9,153.9 199.7,153.3 194.1,145.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "193.6,144.1 193.3,143.8 192.4,142.6 192.2,142.3 191.9,142.6 190.7,143.5 190.4,143.7 190.6,144  191.5,145.2 191.8,145.5 192.1,145.3 193.3,144.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "194,143.3 194.3,143.6 194.6,143.3 195.8,142.5 196.1,142.2 195.9,141.9 195,140.7 194.7,140.4  194.4,140.6 193.2,141.5 192.9,141.8 193.1,142.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.4,129.5c-10.2,0-18.5,8.3-18.5,18.5s8.3,18.5,18.5,18.5s18.5-8.3,18.5-18.5S208.6,129.5,198.4,129.5z  M208.9,158.2h-19.4V156h19.4V158.2z M203.4,154.6h-7.6l-9.1-11.8l10.5-8.1l11.9,15.5L203.4,154.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "195.7,139.6 195.4,139.9 195.7,140.2 196.6,141.4 196.8,141.7 197.1,141.4 198.3,140.6 198.6,140.3  198.4,140 197.5,138.8 197.2,138.5 196.9,138.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "204,149.9 204.1,150 204.9,149.3 199.2,141.9 199.1,141.8 198.3,142.5  "
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M344,165.9l0.3,0c0.4,0,1.1,0.2,1.4,0.5c0.6,0.4,0.8,1.1,0.8,2.3c0,1.2-0.2,1.8-0.7,2.2 c-0.5,0.4-1.1,0.6-2,0.6c-1,0-1.7-0.2-2.2-0.7c-0.4-0.4-0.5-1-0.5-2.1c0-1.1,0.2-1.7,0.7-2.7l1.8-3.2h2.1l-1.8,3H344z M343,168.7 c0,1,0.2,1.4,0.9,1.4c0.6,0,0.9-0.3,0.9-1.4s-0.2-1.4-0.9-1.4C343.2,167.3,343,167.6,343,168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347.6,166c0-1.3,0.2-2,0.6-2.5c0.5-0.6,1.1-0.9,2.1-0.9c1.1,0,1.8,0.3,2.3,1c0.3,0.5,0.5,1.2,0.5,2.4v2.1 c0,1.3-0.2,2-0.6,2.5c-0.5,0.6-1.1,0.9-2.1,0.9c-1.1,0-1.8-0.3-2.3-1c-0.3-0.5-0.5-1.2-0.5-2.4V166z M351.2,166.2 c0-1.5-0.2-2-0.9-2c-0.7,0-0.9,0.5-0.9,2v1.8c0,1.5,0.2,2,0.9,2c0.7,0,0.9-0.5,0.9-2V166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M360.5,171C360.4,171,360.4,171.1,360.5,171c-0.5,0.4-0.9,0.5-1.6,0.5c-1.7,0-2.3-0.8-2.3-2.8v-0.9 c0-2,0.7-2.8,2.3-2.8c0.4,0,0.7,0,1,0.2c0,0,0,0,0.2,0.1c0,0,0,0,0.1,0.1v-2.6h1.8v8.6h-1.3L360.5,171z M358.3,168.6 c0,1.1,0.3,1.5,0.9,1.5c0.6,0,0.9-0.4,0.9-1.2v-1.3c0-0.8-0.3-1.2-0.9-1.2c-0.6,0-0.9,0.5-0.9,1.5V168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M366.7,167.4c0-0.7-0.3-1-0.9-1c-0.5,0-0.8,0.2-1.2,0.6l-1.2-0.8c0.5-0.8,1.4-1.2,2.5-1.2 c1.2,0,1.9,0.4,2.3,1.1c0.2,0.3,0.2,0.8,0.2,1.6v3.7H367l-0.1-0.3c-0.4,0.3-0.8,0.5-1.6,0.5c-1.5,0-2.1-0.5-2.1-2 c0-1.5,0.6-2,2.3-2h1.1V167.4z M365.7,168.7c-0.6,0-0.9,0.2-0.9,0.8c0,0.5,0.2,0.7,0.9,0.7c0.7,0,0.9-0.2,0.9-1v-0.5H365.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M369.2,165.2h1.8l1.2,4.2l1.2-4.2h1.8l-2.2,6.5c-0.8,2.2-1.1,2.4-3.3,2.4v-1.4c1,0,1.2-0.1,1.5-1.1l0.1-0.4 L369.2,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M376.8,169.5c0.3,0.5,0.6,0.6,1.3,0.6c0.8,0,1.1-0.2,1.1-0.7c0-0.3-0.2-0.5-0.7-0.5c-1.1-0.1-1.4-0.2-1.8-0.4 c-0.6-0.3-0.9-0.8-0.9-1.5c0-1.3,0.8-2,2.3-2c1.2,0,2,0.4,2.5,1.3l-1.3,0.7c-0.3-0.5-0.6-0.6-1.1-0.6c-0.5,0-0.8,0.2-0.8,0.6 c0,0.4,0.2,0.5,0.9,0.6c1.9,0.2,2.4,0.6,2.4,2c0,1.4-0.8,2-2.7,2c-1.4,0-2.2-0.4-2.6-1.3L376.8,169.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M671.3,137.8c-1.1,2.5-2.9,4.5-5.2,5.6H666c-0.2,0.1-0.4,0.1-0.5,0s-0.1-0.1-0.2-0.2c-0.1-0.3,0-0.6,0.3-0.7 h0.1c2.2-1,4-3.1,4.9-5.6c-0.4-0.6-0.9-1.1-1.4-1.6L658.3,152l-4-2.6l11.1-17.1c-2.8-1.7-6-2.7-9.5-2.7c-10.2,0-18.5,8.3-18.5,18.5 c0,1.8,0.3,3.5,0.8,5.2c1.4-0.3,2.9-0.5,3.9-0.7c1.8-0.4,3-0.6,3.7-0.8c0.9-0.2,1.4-0.3,1.6,0.2c0.3,0.5-0.1,0.9-0.5,1.2 c-0.6,0.5-1.9,1.6-3.1,3.6c-0.4,0.7-0.4,1-0.3,1c0.5,0.7,4.4,0,8.5-1.4l0.1,0.3l0.5,0.2l0,0l0,0l0.1,0.1l0.4,0.1v0.1v0.1l-0.2,0.2 c-0.1,0.1-0.1,0.1-0.2,0.1h-0.1c-1.3,0.5-5.3,1.8-7.9,1.8c-1.1,0-1.9-0.2-2.3-0.7c-0.5-0.6-0.5-1.5,0.2-2.6c0.5-0.9,1.1-1.7,1.9-2.5 c-0.6,0.1-1.2,0.3-2,0.4c-1.5,0.3-2.7,0.5-3.7,0.7c2.6,7,9.4,11.9,17.3,11.9c10.2,0,18.5-8.3,18.5-18.5 C674.4,144.2,673.2,140.7,671.3,137.8z M653.4,155.5c-0.3,0.2-0.6-0.1-0.5-0.3l0.8-4.9l4,2.6L653.4,155.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "168,143 166.4,144.6 169.4,147.6 111.5,147.6 111.5,149.8 169.4,149.8 166.4,152.8 168,154.4  173.7,148.7 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "281.2,143 279.6,144.6 282.7,147.6 224.7,147.6 224.7,149.8 282.7,149.8 279.6,152.8 281.2,154.4  287,148.7 "
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "308.3,144.1 308,143.8 307.1,142.6 306.9,142.3 306.5,142.6 305.4,143.5 305,143.7 305.3,144  306.2,145.2 306.4,145.5 306.8,145.3 307.9,144.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "310.4,144.5 316.1,151.8 316.2,151.9 317,151.3 311.2,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "308.7,145.8 307.9,146.4 313.5,153.8 313.6,153.9 314.4,153.3 308.7,145.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "310.4,139.6 310.1,139.9 310.3,140.2 311.2,141.4 311.5,141.7 311.8,141.4 313,140.6 313.3,140.3  313.1,140 312.2,138.8 311.9,138.5 311.6,138.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "318.7,149.9 318.8,150 319.6,149.3 313.9,141.9 313.8,141.8 313,142.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M313.1,129.5c-10.2,0-18.5,8.3-18.5,18.5s8.3,18.5,18.5,18.5s18.5-8.3,18.5-18.5S323.3,129.5,313.1,129.5z  M323.5,158.2h-19.4V156h19.4V158.2z M318,154.6h-7.6l-9.1-11.8l10.5-8.1l11.9,15.5L318,154.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "308.7,143.3 309,143.6 309.3,143.3 310.5,142.5 310.8,142.2 310.5,141.9 309.6,140.7 309.4,140.4  309.1,140.6 307.9,141.5 307.6,141.8 307.8,142.1  "
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "396.7,143 395.1,144.6 398.1,147.6 340.2,147.6 340.2,149.8 398.1,149.8 395.1,152.8 396.7,154.4  402.4,148.7 "
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "424.9,144.5 430.6,151.8 430.7,151.9 431.5,151.3 425.7,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "422.7,144.1 422.5,143.8 421.6,142.6 421.3,142.3 421,142.6 419.8,143.5 419.5,143.7 419.8,144  420.7,145.2 420.9,145.5 421.3,145.3 422.4,144.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "423.1,145.8 422.3,146.4 428,153.8 428.1,153.9 428.9,153.3 423.2,145.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M427.6,129.5c-10.2,0-18.5,8.3-18.5,18.5s8.3,18.5,18.5,18.5s18.5-8.3,18.5-18.5 C446,137.8,437.8,129.5,427.6,129.5z M438,158.2h-19.4V156H438V158.2z M432.5,154.6h-7.6l-9.1-11.8l10.5-8.1l11.9,15.5L432.5,154.6 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "423.2,143.3 423.4,143.6 423.8,143.3 424.9,142.5 425.3,142.2 425,141.9 424.1,140.7 423.9,140.4  423.5,140.6 422.4,141.5 422,141.8 422.3,142.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "424.9,139.6 424.6,139.9 424.8,140.2 425.7,141.4 426,141.7 426.3,141.4 427.5,140.6 427.8,140.3  427.5,140 426.6,138.8 426.4,138.5 426,138.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "433.2,149.9 433.3,150 434.1,149.3 428.4,141.9 428.3,141.8 427.5,142.5  "
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "538.5,145.8 537.7,146.4 543.4,153.8 543.4,153.9 544.2,153.3 538.6,145.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "538.5,143.3 538.8,143.6 539.1,143.3 540.3,142.5 540.6,142.2 540.4,141.9 539.5,140.7 539.2,140.4  538.9,140.6 537.7,141.5 537.4,141.8 537.6,142.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "540.3,144.5 546,151.8 546,151.9 546.8,151.3 541.1,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "538.1,144.1 537.8,143.8 537,142.6 536.7,142.3 536.4,142.6 535.2,143.5 534.9,143.7 535.1,144  536,145.2 536.3,145.5 536.6,145.3 537.8,144.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "548.5,149.9 548.6,150 549.4,149.3 543.7,141.9 543.6,141.8 542.8,142.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "540.2,139.6 539.9,139.9 540.2,140.2 541.1,141.4 541.3,141.7 541.6,141.4 542.8,140.6 543.1,140.3  542.9,140 542,138.8 541.7,138.5 541.4,138.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.9,129.5c-10.2,0-18.5,8.3-18.5,18.5s8.3,18.5,18.5,18.5s18.5-8.3,18.5-18.5S553.1,129.5,542.9,129.5z  M553.4,158.2H534V156h19.4V158.2z M547.9,154.6h-7.6l-9.1-11.8l10.5-8.1l11.9,15.5L547.9,154.6z"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "510.4,143 508.8,144.6 511.8,147.6 453.9,147.6 453.9,149.8 511.8,149.8 508.8,152.8 510.4,154.4  516.1,148.7 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "626.6,143 625,144.6 628,147.6 569.2,147.6 569.2,149.8 628,149.8 625,152.8 626.6,154.4 632.3,148.7  "
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 201.1,
    className: "st0",
    width: 71.5,
    height: 17.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.9,206.3h-0.7v-6.4h2.1c0.8,0,1.3,0.1,1.6,0.5c0.3,0.3,0.5,0.8,0.5,1.5c0,0.7-0.2,1.2-0.5,1.5 c-0.3,0.3-0.8,0.4-1.5,0.4h-1.3V206.3z M31.2,203.1c0.9,0,1.3-0.4,1.3-1.3c0-0.9-0.4-1.3-1.3-1.3h-1.3v2.7H31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.1,201.7v2.5c0,0.4,0,0.7,0.1,0.9c0.1,0.4,0.4,0.6,0.9,0.6c0.7,0,1-0.5,1-1.7v-2.3h0.7v4.5h-0.5l-0.1-0.5 c-0.3,0.4-0.6,0.6-1.2,0.6c-0.8,0-1.3-0.3-1.5-0.9c-0.1-0.3-0.1-0.6-0.1-1.1v-2.6H35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.5,199.8h0.7v2.2c0.3-0.3,0.7-0.4,1.2-0.4c1.2,0,1.7,0.6,1.7,2v0.7c0,1.4-0.5,2-1.7,2 c-0.4,0-0.8-0.1-1.1-0.3c0,0-0.1-0.1-0.3-0.2l0,0.4h-0.6V199.8z M42.4,203.7c0-1-0.4-1.5-1.1-1.5c-0.8,0-1.1,0.5-1.1,1.4v0.7 c0,0.9,0.4,1.4,1.1,1.4c0.7,0,1.1-0.5,1.1-1.5V203.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.2,199.8v5c0,0.6,0.2,0.8,0.8,0.8h0.2v0.6H46c-1.1,0-1.4-0.3-1.4-1.5v-4.9H45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.2,199.8h0.7v1h-0.7V199.8z M47.2,201.7h0.7v4.5h-0.7V201.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.7,205.6c-0.3,0.5-0.8,0.7-1.5,0.7c-1.2,0-1.8-0.7-1.8-2.1v-0.4c0-1.5,0.6-2.2,1.8-2.2 c0.7,0,1.2,0.2,1.5,0.7l-0.5,0.3c-0.3-0.3-0.5-0.5-0.9-0.5c-0.8,0-1.1,0.5-1.1,1.6v0.5c0,0.9,0.4,1.4,1.1,1.4c0.4,0,0.7-0.1,1-0.4 L52.7,205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.4,206.3h-0.7v-6.4h2.1c0.8,0,1.3,0.1,1.6,0.5c0.3,0.3,0.5,0.8,0.5,1.5c0,0.7-0.2,1.2-0.5,1.5 c-0.3,0.3-0.8,0.4-1.5,0.4h-1.3V206.3z M57.8,203.1c0.9,0,1.3-0.4,1.3-1.3c0-0.9-0.4-1.3-1.3-1.3h-1.3v2.7H57.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.6,203.3c0-0.4,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.3-0.8-0.3c-0.4,0-0.8,0.2-1.1,0.5l-0.5-0.4 c0.4-0.5,0.9-0.7,1.6-0.7c0.7,0,1.2,0.2,1.5,0.7c0.1,0.3,0.2,0.5,0.2,1.1v2.9h-0.6l-0.1-0.3c-0.3,0.3-0.6,0.4-1.3,0.4 c-1.2,0-1.6-0.4-1.6-1.3c0-1,0.4-1.4,1.7-1.4h1.1V203.3z M62.6,204.1c-0.8,0-1.1,0.2-1.1,0.8c0,0.6,0.3,0.8,1.1,0.8 c0.5,0,0.8-0.1,0.9-0.3c0.1-0.1,0.1-0.3,0.1-0.6v-0.7H62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.9,201.7h0.6l0.1,0.4c0.3-0.4,0.6-0.5,1.1-0.5c0.3,0,0.6,0.1,0.9,0.2l-0.3,0.6c-0.2-0.2-0.4-0.2-0.6-0.2 c-0.7,0-0.9,0.5-0.9,1.8v2.2h-0.7V201.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.3,202.3v-0.6h0.5l0-1.4h0.7v1.4h0.9v0.6h-0.9v2.5c0,0.6,0.2,0.8,0.8,0.8h0.2v0.6h-0.2 c-1.2,0-1.5-0.3-1.5-1.5v-2.4H69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.7,199.8h0.7v1h-0.7V199.8z M72.7,201.7h0.7v4.5h-0.7V201.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.2,205.6c-0.3,0.5-0.8,0.7-1.5,0.7c-1.2,0-1.8-0.7-1.8-2.1v-0.4c0-1.5,0.6-2.2,1.8-2.2 c0.7,0,1.2,0.2,1.5,0.7l-0.5,0.3c-0.3-0.3-0.5-0.5-0.9-0.5c-0.8,0-1.1,0.5-1.1,1.6v0.5c0,0.9,0.4,1.4,1.1,1.4c0.4,0,0.7-0.1,1-0.4 L78.2,205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.3,199.8H80v1h-0.7V199.8z M79.3,201.7H80v4.5h-0.7V201.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.6,201.7h0.6l0.1,0.4c0.3-0.3,0.7-0.5,1.3-0.5c1.2,0,1.7,0.6,1.7,2v0.7c0,1.4-0.5,2-1.7,2 c-0.5,0-0.9-0.1-1.2-0.4v2.4h-0.7V201.7z M84.5,203.7c0-1-0.4-1.5-1.1-1.5c-0.7,0-1.1,0.5-1.1,1.4v0.7c0,0.9,0.4,1.4,1.1,1.4 c0.7,0,1.1-0.5,1.1-1.5V203.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.1,203.3c0-0.4,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.3-0.8-0.3c-0.4,0-0.8,0.2-1.1,0.5l-0.5-0.4 c0.4-0.5,0.9-0.7,1.6-0.7c0.7,0,1.2,0.2,1.5,0.7c0.1,0.3,0.2,0.5,0.2,1.1v2.9h-0.6l-0.1-0.3c-0.3,0.3-0.6,0.4-1.3,0.4 c-1.2,0-1.6-0.4-1.6-1.3c0-1,0.4-1.4,1.7-1.4h1.1V203.3z M88.1,204.1c-0.8,0-1.1,0.2-1.1,0.8c0,0.6,0.3,0.8,1.1,0.8 c0.5,0,0.8-0.1,0.9-0.3c0.1-0.1,0.1-0.3,0.1-0.6v-0.7H88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91,202.3v-0.6h0.5l0-1.4h0.7v1.4h0.9v0.6h-0.9v2.5c0,0.6,0.2,0.8,0.8,0.8h0.2v0.6H93c-1.2,0-1.5-0.3-1.5-1.5 v-2.4H91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.4,199.8h0.7v1h-0.7V199.8z M94.4,201.7h0.7v4.5h-0.7V201.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.5,203.6c0-1.4,0.6-2,1.9-2c1.3,0,1.9,0.6,1.9,2v0.7c0,1.4-0.6,2-1.9,2c-1.3,0-1.9-0.6-1.9-2V203.6z  M99.5,203.7c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.5v0.6c0,1,0.4,1.4,1.2,1.4c0.8,0,1.2-0.5,1.2-1.4V203.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.7,201.7h0.5l0.1,0.5c0.3-0.4,0.7-0.6,1.3-0.6c0.8,0,1.3,0.3,1.5,0.9c0.1,0.3,0.1,0.6,0.1,1.1v2.6h-0.7 v-2.5c0-1.1-0.3-1.5-1-1.5c-0.8,0-1.1,0.5-1.1,1.7v2.3h-0.7V201.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29,211c0-0.9,0.2-1.4,0.5-1.8c0.4-0.5,0.9-0.7,1.7-0.7c0.8,0,1.4,0.2,1.8,0.8c0.3,0.4,0.4,0.9,0.4,1.7v1.6 c0,0.9-0.1,1.4-0.5,1.8c-0.4,0.5-0.9,0.7-1.7,0.7c-0.8,0-1.4-0.2-1.8-0.8c-0.3-0.4-0.4-0.9-0.4-1.7V211z M32.8,211.1 c0-0.7-0.1-1.1-0.4-1.4c-0.3-0.4-0.6-0.5-1.2-0.5c-0.6,0-1,0.2-1.2,0.6c-0.2,0.3-0.3,0.7-0.3,1.3v1.4c0,0.7,0.1,1.1,0.4,1.4 c0.3,0.4,0.6,0.5,1.2,0.5c0.6,0,1-0.2,1.2-0.6c0.2-0.3,0.3-0.7,0.3-1.4V211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.1,210.5h0.6l0.1,0.4c0.3-0.3,0.7-0.5,1.3-0.5c1.2,0,1.7,0.6,1.7,2v0.7c0,1.4-0.5,2-1.7,2 c-0.5,0-0.9-0.1-1.2-0.4v2.4h-0.7V210.5z M38,212.5c0-1-0.4-1.5-1.1-1.5c-0.7,0-1.1,0.5-1.1,1.4v0.7c0,0.9,0.4,1.4,1.1,1.4 c0.7,0,1.1-0.5,1.1-1.5V212.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.2,210.5h0.6l0.1,0.4c0.3-0.3,0.7-0.5,1.3-0.5c1.2,0,1.7,0.6,1.7,2v0.7c0,1.4-0.5,2-1.7,2 c-0.5,0-0.9-0.1-1.2-0.4v2.4h-0.7V210.5z M43.1,212.5c0-1-0.4-1.5-1.1-1.5c-0.7,0-1.1,0.5-1.1,1.4v0.7c0,0.9,0.4,1.4,1.1,1.4 c0.7,0,1.1-0.5,1.1-1.5V212.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.1,212.4c0-1.4,0.6-2,1.9-2c1.3,0,1.9,0.6,1.9,2v0.7c0,1.4-0.6,2-1.9,2c-1.3,0-1.9-0.6-1.9-2V212.4z  M48.1,212.5c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.5v0.6c0,1,0.4,1.4,1.2,1.4c0.8,0,1.2-0.5,1.2-1.4V212.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.3,210.5h0.6l0.1,0.4c0.3-0.4,0.6-0.5,1.1-0.5c0.3,0,0.6,0.1,0.9,0.2l-0.3,0.6c-0.2-0.2-0.4-0.2-0.6-0.2 c-0.7,0-0.9,0.5-0.9,1.8v2.2h-0.7V210.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.7,211.1v-0.6h0.5l0-1.4h0.7v1.4h0.9v0.6h-0.9v2.5c0,0.6,0.2,0.8,0.8,0.8h0.2v0.6h-0.2 c-1.2,0-1.5-0.3-1.5-1.5v-2.4H53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.8,210.5v2.5c0,0.4,0,0.7,0.1,0.9c0.1,0.4,0.4,0.6,0.9,0.6c0.7,0,1-0.5,1-1.7v-2.3h0.7v4.5H60l-0.1-0.5 c-0.3,0.4-0.6,0.6-1.2,0.6c-0.8,0-1.3-0.3-1.5-0.9c-0.1-0.3-0.1-0.6-0.1-1.1v-2.6H57.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.1,210.5h0.5l0.1,0.5c0.3-0.4,0.7-0.6,1.3-0.6c0.8,0,1.3,0.3,1.5,0.9c0.1,0.3,0.1,0.6,0.1,1.1v2.6h-0.7 v-2.5c0-1.1-0.3-1.5-1-1.5c-0.8,0-1.1,0.5-1.1,1.7v2.3h-0.7V210.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.2,208.6h0.7v1h-0.7V208.6z M67.2,210.5h0.7v4.5h-0.7V210.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.1,211.1v-0.6h0.5l0-1.4h0.7v1.4h0.9v0.6h-0.9v2.5c0,0.6,0.2,0.8,0.8,0.8h0.2v0.6h-0.2 c-1.2,0-1.5-0.3-1.5-1.5v-2.4H69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.2,210.5h0.7l1.3,3.7l1.2-3.7h0.7l-1.8,5.2c-0.4,1.1-0.7,1.3-1.8,1.3v-0.6c0.7,0,0.8-0.1,1.1-0.8l0.2-0.7 L72.2,210.5z"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.1,212.6c-0.1-0.6-0.3-1.3-0.3-1.8c-0.2,0-0.7,0.1-1,0.1c-0.7,0-1.4,0.2-1.9,0.3c0.2,0.3,0.4,1,0.6,1.4 c0.3,0.6,0.6,1.2,0.9,1.8c0.3,0.5,0.6,0.8,0.8,0.9l0,0c0.2,0.1,0.5,0.2,0.6,0.1l1-0.2c0.1,0,0.2-0.1,0.3-0.2 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.3-0.2-0.5-0.5-0.9C12.4,213.5,12.2,213.2,12.1,212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M10,211.4l-0.9-3.9c-0.3,0.1-1.8,0.4-2,0.4c-0.7,0.1-1.1,0.8-0.9,1.5l0.3,1.5c0.1,0.7,0.8,1.1,1.5,0.9 L10,211.4L10,211.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.7,213.2c-1-4.7-1.6-7.4-2.6-11.8c0-0.2-0.3-0.3-0.5-0.3c-0.1,0-0.2,0.1-0.2,0.2c-1.4,2.8-3.3,4.1-7.2,5.2 c-0.1,0-0.4,0.1-0.7,0.2c-0.4,0.1-0.6,0.5-0.5,0.9l0.8,3.6c0.1,0.4,0.5,0.7,0.9,0.6l0.3-0.1c0.8-0.1,2.1-0.2,2.1-0.2 c3.1-0.2,4.7,0.4,6.8,2c0.1,0.1,0.3,0.1,0.4,0C20.7,213.4,20.7,213.3,20.7,213.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUlurp2);
export default __webpack_public_path__ + "static/media/ulurp2.5595a541a5878654ebabca77c68c329c.svg";
export { ForwardRef as ReactComponent };